"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _UINavListItem = _interopRequireDefault(require("./UINavListItem"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _default = _react.default.createClass({
  displayName: "UIFolderNavItem",
  propTypes: (0, _extends2.default)({}, _UINavListItem.default.propTypes),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UINavListItem.default.defaultProps);
  },
  getIcon: function getIcon() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        children = _ref.children,
        className = _ref.className,
        open = _ref.open,
        size = _ref.size;

    var icon = 'file';

    if (children != null) {
      icon = open ? 'folderOpen' : 'folder';
    }

    return _react.default.createElement(_UIIcon.default, {
      className: (0, _classNames.default)('private-folder-nav-item__icon', className),
      name: icon,
      size: size
    });
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className"]);
    return _react.default.createElement(_UINavListItem.default, (0, _extends2.default)({
      className: (0, _classNames.default)('private-folder-nav-item', className),
      iconLeft: this.getIcon
    }, rest), children);
  }
});

exports.default = _default;
module.exports = exports.default;